module.exports = __webpack_public_path__ + "assets/ec18fea7ed7215ebf5665ee23eb26fcf.svg";